module.exports = __webpack_public_path__ + "static/media/logo-blanco.ec9d536c.svg";